import type { Product } from '@/types';
import * as Styled from './ProductTileModal.styled';

interface ProductLinkProps {
  product: Product;
}

export const ProductLink = ({ product }: ProductLinkProps) => (
  <Styled.ProdLink className="product-link" href={product.productUrl ?? ''}>
    <Styled.Title>{product.name}</Styled.Title>
    {product.author ? <Styled.ByLine>{product.author}</Styled.ByLine> : null}
    {product.format ? (
      <Styled.Format>{product.format}</Styled.Format>
    ) : null}
    {product.price ? (
      <Styled.Price>{product.price.current}</Styled.Price>
    ) : null}
  </Styled.ProdLink>
);
